// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UmaGkW9kih0je2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  gap: var(--ds-space-100, 8px);
}
.fHxlSFM3hMG58A {
  display: flex;
  margin-bottom: var(--ds-space-050, 4px);
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px) var(--ds-space-075, 6px) var(--ds-space-150, 10px);
  border-radius: var(--ds-border-radius-100, 3px);
}
.fHxlSFM3hMG58A:disabled {
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  color: var(--ds-text, #172b4d);
}
.fHxlSFM3hMG58A:disabled:hover {
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  color: var(--ds-text, #172b4d);
}
`, ""]);
// Exports
export var buttonContent = `UmaGkW9kih0je2`;
export var placeholderButton = `fHxlSFM3hMG58A`;
export default ___CSS_LOADER_EXPORT___;
